/** @file rowOfDrawable: the impostor row that draws a given drawable this frame, or -1. */
import type { ImpostorList } from '@zilo/pose3d-render-core/contract';
import { IMPOSTOR_LAYOUT as L } from '@zilo/pose3d-render-core/layout/impostorLayout';

/** The first of the `count` placed impostors whose `drawable` slot is `drawableIndex`; -1 when none draws it. */
export function rowOfDrawable(list: ImpostorList, count: number, drawableIndex: number): number {
  for (let i = 0; i < count; i++) if (list[i * L.stride + L.drawable] === drawableIndex) return i;
  return -1;
}
